export type CompositeLocationAvatarSize = 'sm' | 'md' | 'lg' | 'xl'

export type CompositeLocationAvatarLocation = {
    imageUrl?: string | null
    name: string
}

export type CompositeLocationAvatarProps = {
    /** Locations to composite. Order matters — first N are shown, rest roll into "+N". */
    locations: CompositeLocationAvatarLocation[]
    /** Named token ('sm' | 'md' | 'lg' | 'xl') or pixel number. Default 'md'. */
    size?: CompositeLocationAvatarSize | number
    /** Merged with default classes. */
    className?: string
}

export const SIZE_MAP: Record<CompositeLocationAvatarSize, number> = {
    sm: 32,
    md: 48,
    lg: 64,
    xl: 96,
}
